import React from "react";
import "./Home.css";
import img1 from "../../img/screens.png";
import feature1 from "../../img/feature-ils-1.svg";
import feature2 from "../../img/feature-ils-2.svg";
import feature3 from "../../img/feature-ils-3.svg";
import Rellax from "../../Components/Rellax/Rellax";
import Feature from "../../Components/Feature/Feature";
const Home = () => {
  return (
    <div className="Home">
      
      <header>
        <div className="container mt-5 pt-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="title text-center mt-5">
                <h2 className="fw-bold">
                  🚚🚛 هل أنت بحاجة إلى نقل أثاثك أو بضائعك في الرياض؟{" "}
                </h2>
                <p>
                  شركة (اسم شركتك) لخدمات النقل المتكاملة تقدم لك أفضل الحلول
                  لجميع احتياجات النقل الخاصة بك في الرياض وخارجها.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <img src={img1} alt="" />
            </div>
          </div>
        </div>
      </header>

      <Feature />

      <Rellax />

      <section className="discont editorial">
        <svg
          className="top"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z"
            />
          </defs>
          <g className="parallax1">
            <use href="#gentle-wave" x="50" y="3" fill="#f9c7ac" />
          </g>
          <g className="parallax3">
            <use href="#gentle-wave" x="50" y="9" fill="#ed9e73" />
          </g>
          <g className="parallax4">
            <use href="#gentle-wave" x="50" y="6" fill="#df814e" />
          </g>
        </svg>
        <div className="contant">
          <h3 className="text text-white mb-4 fw-bold">
            أقل الأسعار بغض النظر عن مقدار الشحن
          </h3>
          <p className="text-white">
            قارن الأسعار في الوقت الفعلي وأوقات التسليم لجميع شركات النقل وحدد
            تلقائيًا أفضل شركة نقل لكل شحنة بناءً على التكلفة ووقت التسليم. بفضل
            انضمتنا الرائعة ، تفاوضنا على الأسعار المحجوزة للعديد من الشركات ،
            لاجل راحتكم.
          </p>
        </div>
        <svg
          className="botom "
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z"
            />
          </defs>
          <g className="parallax1">
            <use href="#gentle-wave" x="50" y="3" fill="#f9c7ac" />
          </g>
          <g className="parallax3">
            <use href="#gentle-wave" x="50" y="9" fill="#ed9e73" />
          </g>
          <g className="parallax4">
            <use href="#gentle-wave" x="50" y="6" fill="#df814e" />
          </g>
        </svg>
      </section>

      <section className="successes text-center">
        <div className="container">
          <div className="row g-0 gap-0 align-items-center justify-content-center">
            <div className="col-6 col-md-3 ">
              <div className="crd crd-1">
                <h3>15,000</h3>
                <p>بائع</p>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="crd crd-2">
                <h3>+25</h3>
                <p>مخزن</p>
              </div>
            </div>

            <div className="col-6 col-md-3 align-items-center">
              <div className="crd crd-3  ">
                <h3>1,000</h3>
                <p>مندوب</p>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="crd crd-4">
                <h3>10,000,000</h3>
                <p>طرود ناجحة</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="shop-now mt-5 text-center">
        <a className="btn btn-danger " href="#">سجل الآن وابدأ الشحن اليوم..</a>
      </section>
    </div>
  );
};

export default Home;
